<template>
    <header class="header_fix">
    <nav class="navbar">
      <a class="navbar-brand new_logo_well" v-on:click="homeRedircet()">
        <img src="@/assets/images/white_l_logo.png" class="img-fluid" alt="" width="60">
        <span class="administration_text">Administration Portal</span>
      </a>
      <ul v-if="!isMobile" class="header_menu ml-auto mr-0">
        <li class="list-items">
          <router-link class="menu_text_link" to="/lbil/dashboard/">
            <span class="menu_icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="40" height="40" x="0" y="0"
                viewBox="0 0 460.298 460.297" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
                <g>
                  <g xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <path
                        d="M230.149,120.939L65.986,256.274c0,0.191-0.048,0.472-0.144,0.855c-0.094,0.38-0.144,0.656-0.144,0.852v137.041    c0,4.948,1.809,9.236,5.426,12.847c3.616,3.613,7.898,5.431,12.847,5.431h109.63V303.664h73.097v109.64h109.629    c4.948,0,9.236-1.814,12.847-5.435c3.617-3.607,5.432-7.898,5.432-12.847V257.981c0-0.76-0.104-1.334-0.288-1.707L230.149,120.939    z"
                        fill="#7ac70c" data-original="#000000" style="" />
                      <path
                        d="M457.122,225.438L394.6,173.476V56.989c0-2.663-0.856-4.853-2.574-6.567c-1.704-1.712-3.894-2.568-6.563-2.568h-54.816    c-2.666,0-4.855,0.856-6.57,2.568c-1.711,1.714-2.566,3.905-2.566,6.567v55.673l-69.662-58.245    c-6.084-4.949-13.318-7.423-21.694-7.423c-8.375,0-15.608,2.474-21.698,7.423L3.172,225.438c-1.903,1.52-2.946,3.566-3.14,6.136    c-0.193,2.568,0.472,4.811,1.997,6.713l17.701,21.128c1.525,1.712,3.521,2.759,5.996,3.142c2.285,0.192,4.57-0.476,6.855-1.998    L230.149,95.817l197.57,164.741c1.526,1.328,3.521,1.991,5.996,1.991h0.858c2.471-0.376,4.463-1.43,5.996-3.138l17.703-21.125    c1.522-1.906,2.189-4.145,1.991-6.716C460.068,229.007,459.021,226.961,457.122,225.438z"
                        fill="#7ac70c" data-original="#000000" style="" />
                    </g>
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg">
                  </g>
                </g>
              </svg>
            </span>
            <span class="menu_text"> Home</span>
          </router-link>
        </li>
        <!-- <li class="list-items" v-if="showBtn && is_superuser">
          <router-link class="menu_text_link" to="/lbil/admin/">
            <span class="menu_icon">
              <img src="@/assets/images/lbil_logo.png" class="img-fluid normal_view" style="width:22px;margin-top:1px;">
              <img src="@/assets/images/lbil_logo_black.png" class="img-fluid hover_view" style="width:22px;margin-top:1px;">
              </span>
              <span class="menu_text">LBIL Admin</span>
          </router-link>
        </li> -->
        <li class="list-items logout_btn" v-if="showBtn">
          <a href="javascript:void(0)" v-on:click.prevent="logout()" class="menu_text_link" v-if="showBtn">
            <span class="menu_icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="31" height="31" x="0" y="0"
                viewBox="0 0 512.00533 512" style="enable-background:new 0 0 512 512;margin-top:2px;" xml:space="preserve"
                class="">
                <g>
                  <path xmlns="http://www.w3.org/2000/svg"
                    d="m320 277.335938c-11.796875 0-21.332031 9.558593-21.332031 21.332031v85.335937c0 11.753906-9.558594 21.332032-21.335938 21.332032h-64v-320c0-18.21875-11.605469-34.496094-29.054687-40.554688l-6.316406-2.113281h99.371093c11.777344 0 21.335938 9.578125 21.335938 21.335937v64c0 11.773438 9.535156 21.332032 21.332031 21.332032s21.332031-9.558594 21.332031-21.332032v-64c0-35.285156-28.714843-63.99999975-64-63.99999975h-229.332031c-.8125 0-1.492188.36328175-2.28125.46874975-1.027344-.085937-2.007812-.46874975-3.050781-.46874975-23.53125 0-42.667969 19.13281275-42.667969 42.66406275v384c0 18.21875 11.605469 34.496093 29.054688 40.554687l128.386718 42.796875c4.351563 1.34375 8.679688 1.984375 13.226563 1.984375 23.53125 0 42.664062-19.136718 42.664062-42.667968v-21.332032h64c35.285157 0 64-28.714844 64-64v-85.335937c0-11.773438-9.535156-21.332031-21.332031-21.332031zm0 0"
                    fill="#ffffff" data-original="#000000" style="" class="" />
                  <path xmlns="http://www.w3.org/2000/svg"
                    d="m505.75 198.253906-85.335938-85.332031c-6.097656-6.101563-15.273437-7.9375-23.25-4.632813-7.957031 3.308594-13.164062 11.09375-13.164062 19.714844v64h-85.332031c-11.777344 0-21.335938 9.554688-21.335938 21.332032 0 11.777343 9.558594 21.332031 21.335938 21.332031h85.332031v64c0 8.621093 5.207031 16.40625 13.164062 19.714843 7.976563 3.304688 17.152344 1.46875 23.25-4.628906l85.335938-85.335937c8.339844-8.339844 8.339844-21.824219 0-30.164063zm0 0"
                    fill="#ffffff" data-original="#000000" style="" class="" />
                </g>
              </svg>
            </span>
            <span class="menu_text">Logout</span>
          </a>
        </li>
      </ul>
      <!-- <mobileMenuBar v-if="isMobile" :notificationBadgeINFO="notificationBadgeInfo"></mobileMenuBar> -->
    </nav>
  </header>
</template>
<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');

import { bus } from '@/main';
import { mapGetters } from 'vuex';
// import mobileMenuBar from '@/mobileMenuBar/index.vue';

export default {
  name: 'lymphomap-header',
  components: {
    // mobileMenuBar
  },
  props: [],
  data () {
    return {
      showBtn:true,
      is_superuser:Boolean,
      is_admin:Boolean,
      userRoleType:'',
      isMobile:false,
      selfUserInfo:null,
      accessFeaturesOfPackageState:false,
      notificationBadgeInfo:null,
    }
  },
  computed: {
    ...mapGetters([
      'selfUserInfoGetters'
    ]),
    getUserDetailsAgainFun(){
      this.selfUserInfo = this.$store.getters.selfUserInfoGetters.data
      return;
    },
  },
  mounted () {
    bus.$on('showHeaderbtn', (data) => {
      this.showBtn = data;
    });
    bus.$on('clearNotificationBadgeInfo', (data) => {
      this.notificationBadgeInfo = data;
    });
  },
  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 769
    },
    handleScroll() {
      let header = document.querySelector(".header_fix");
      let covid_19_popup = document.querySelector(".covid_19_popup");
      if (window.scrollY > 30 && !header.className.includes('darkBg')) {
        header.classList.add('darkBg');
        if(covid_19_popup){
          covid_19_popup.classList.add('moved_to_top_icon');
        }
        } else if (window.scrollY < 30) {
          header.classList.remove('darkBg');
          if(covid_19_popup){
          covid_19_popup.classList.remove('moved_to_top_icon');
          }
        }
    },
    logOutUser() {
      if ('BroadcastChannel' in self) {
        authChannel.postMessage({
          cmd: 'logout'
        })
      }
    },
    logout(){
      this.$store.dispatch('logoutFromApiLBILAction')
      .then(() => {
        this.logOutUser()
        window.location.href = '/';
      })
    },
    homeRedircet(){
      window.location.href = '/';
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
}
</script>
<style lang="scss" scoped>
header {
background: rgba(0, 0, 0, 0.8);
}
.header_fix.darkBg {
    background: #000;
}
header .navbar-brand{
transform-origin: center center;
-webkit-transform-origin: center center;}
.header_menu{margin-bottom:0px;}
.header_menu li .btn-default.planet_img img {
width:37px;
}
.header_menu li {display: inline-block; vertical-align: middle; margin-right:18px;}
.header_menu li:last-child{margin-right:0px;}
.header_menu li .btn-default{line-height: 34px;background:rgba(255,255,255,0.07);color:#ffffff;font-size:15px;padding:0px 20px;transition:all ease 0.5s;-webkit-transition:all ease 0.5s;-moz-transition:all ease 0.5s;box-shadow:none;outline:0px;min-width:115px;font-weight:normal;}
.header_menu li .btn-default.Q_btn{font-size: 30px;}
.header_menu li .btn-default .img-fluid {width: 45px;}
.hover_img{display:none;}
.header_menu li .btn-default:hover .hover_img{display:inline-block;}
.header_menu li .btn-default:hover .normal_img{display:none;}
.header_menu li .btn-default:hover{background:#ffffff;color:#000000;font-weight:bold;}
header .list-items a {
    background: rgba(255, 255, 255, 0.07);
    color: #ffffff;
    padding: 0px 42px;
    transition: all ease 0.5s;
    -webkit-transition: all ease 0.5s;
    height: 40px;
    line-height: 40px;
    display: inline-block;
    font-size: 16px;
    border-radius: 4px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-decoration:none;
}
header .list-items a:hover,
header .list-items a.menu_text_link.router-link-active:hover {
    background: #87cefa;
    color: #000000;
}
header .list-items a.menu_text_link.router-link-active .menu_icon .img-fluid{filter:invert(1);}
header .list-items a.menu_text_link.router-link-active svg path{fill:#000000;}
header .list-items a.menu_text_link.router-link-active .fa{color:#000000 !important;}
header .list-items a.menu_text_link.router-link-active svg circle{fill:#000000;}
header .list-items a.menu_text_link{
letter-spacing: .03em;
font-size: 16px;
cursor: pointer;
-webkit-transition: all .5s cubic-bezier(.42,1.14,1,1);
transition: all .5s cubic-bezier(.42,1.14,1,1);
display:flex;white-space: nowrap;overflow: hidden;
min-width: 85px;
padding: 0px 10px;
position: relative;
text-align:center}
.menu_text_link .menu_text{
display:block;
opacity: 0;
max-width: 0;
transition: all .5s ease;
-webkit-transition: all .5s ease;
-moz-transition: all ease .5s;
color:#000;
word-spacing:3px;
margin:0 auto}
.menu_text_link .menu_icon {
position: absolute;
opacity: 1;
left: 0;
right: 0;
margin: 0 auto;
transition: all 1s cubic-bezier(.42,1.14,1,1);
-webkit-transition: all 1s cubic-bezier(.42,1.14,1,1);
-moz-transition: all 1s cubic-bezier(.42,1.14,1,1);
text-align:center
}
.menu_text_link:hover .menu_icon{
opacity:0;
transition: all .1s cubic-bezier(.42,1.14,1,1);
-webkit-transition: all .1s cubic-bezier(.42,1.14,1,1);
-moz-transition: all .1s cubic-bezier(.42,1.14,1,1);
}
.menu_text_link.router-link-active .menu_text{
transition: all .4s ease;
-webkit-transition: all .4s ease;
-moz-transition: all ease .4s;
}
.menu_text_link.router-link-active .menu_icon {
    transition: all 1s cubic-bezier(.42,1.14,1,1);
    -webkit-transition: all 1s cubic-bezier(.42,1.14,1,1);
    -moz-transition: all 1s cubic-bezier(.42,1.14,1,1);
}
.menu_text_link.router-link-active:hover .menu_icon{
transition: all .1s cubic-bezier(.42,1.14,1,1);
-webkit-transition: all .1s cubic-bezier(.42,1.14,1,1);
-moz-transition: all .1s cubic-bezier(.42,1.14,1,1);
}
.menu_text_link:hover .menu_text{
opacity: 1;
max-width:360px;
}
header .list-items a.menu_text_link:hover{
min-width:150px !important;
}
// header.header_fix{z-index:100000;}
header .navbar-brand{position: relative;}
header .navbar-brand .bell_link {
    position: absolute;
    display: inline-block;
    width: 48px;
    height: 27px;
    background: no-repeat;
    cursor: pointer;
    right: 27px;
    bottom: 6px;
}
.new_logo_well {
    transform:scale(1);
    -webkit-transform:scale(1);
    -moz-transform:scale(1);
    transition:transform ease 0.5s;
    -webkit-transition:transform ease 0.5s;
    -moz-transition:transform ease 0.5s;
    transform-origin:center center !important;
    padding:0px;
}
.new_logo_well:hover{
    transform:scale(1.07);
    -webkit-transform:scale(1.07);
    -moz-transform:scale(1.07);
}
@media only screen and (max-width:1300px){
header .list-items a.menu_text_link{min-width: 95px;padding: 0px 5px;}
}
.badge_wrp .badge {
    position: absolute;
    right: -5px;
    top: -5px;
    font-size: 10px;
    font-family: 'MyriadProRegular','Lato',sans-serif;
    font-style: normal;
    width: 18px;
    height: 18px;
    line-height: 17px;
    padding: 0;
    background: rebeccapurple;
    color: #fff;
    border-radius: 2px;
    z-index: 100;
    font-style: italic;
    border-radius: 20px;
}
.badge_wrp {
    position: relative;
}
.badge_wrp .badge.connectionRequest {
    left: -5px;
    background-color: #28a745;
    font-style: italic;
    border-radius: 20px;
    // color:#000000;
}
.support_notofication_counter.badge_wrp .badge {
    background: rebeccapurple;
}
.navbar-brand,
.navbar-brand a{cursor: pointer;}
.meeting_icon_in_header{
.cls-1 {fill: #f60;}
.cls-2 {fill: #000000;}
}
header .list-items.meeting_icon_in_header a.menu_text_link.router-link-active svg{   
& .cls-1 {fill: #000000;}
& .cls-2 {fill: #87cefa;}
}
header .list-items a.menu_text_link.router-link-active .menu_icon .img-fluid.normal_view,
.img-fluid.hover_view{display:none;}
header .list-items a.menu_text_link.router-link-active .menu_icon .img-fluid.hover_view{display:inline-block;filter:none;}
.administration_text {
    display: block;
    font-size: 12px;
    margin-top: 6px;
    color: #e8f899;
    letter-spacing: 0.5px;
    line-height:1;
}
</style>